import { GET } from './apiHandler';
import { API_BASE_URL } from 'src/globals';
import { ALL_COUNTRY, SEARCH_COUNTRY } from './routes';

export const searchCountry = async (params) => {
  return await GET(`${API_BASE_URL}${SEARCH_COUNTRY}`, params);
};

export const getAllCountry = async () =>{
  return await GET(`${API_BASE_URL}${ALL_COUNTRY}`);
}
